import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.05.385.434.24 3.612 2 4.58-1.57L16 .6v12.336l-.595.264-5 2.215-.454.2-.435-.24-3.612-2-4.58 1.571L0 15.4V3.064L.595 2.8l5-2.214.455-.201ZM2 4.365V12.6l3-1.028V3.037L2 4.365Zm7 8.438-2-1.107v-8.5l2 1.108v8.5Zm2 .16 3-1.328V3.4l-3 1.03v8.535Z",
    fill: "currentColor"
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Map16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */
export var Map16 = createIcon(IconComponent);